export enum DateFormatEnum {
    OnlyDate = 'dd-MM-yyyy',
    Full = 'dd-MM-yyyy, HH:mm'
}
